<template>
    <!--
        T32-tiles (walk 2026-09-18, `tasks-T32-T33.md`, "Wanted" block 4, last bullet; the reference is
        `mock/design-walk/r11-images-dropzone-media.html`, the fourth screen): EDIT IMAGE NOTES, ON THE
        RUN'S ONE MODAL SHELL.

        THE SHELL IS T30's `AFModal`, ADOPTED AND NOT HAND-WRITTEN (`notes/T30.md` section 0;
        `notes/T31-shell-adoption.md` section 0.1 is the run's checked pattern). It draws the sheet's F5
        block: `modal-class="ftd af-modal"`, `.ftd-modal--lg` from its own `size="lg"`, the head with the
        image's name as `.ftd-modal__sub`, the `ftd-modal__x` close, and a `--right` footer of the
        red-outlined Cancel and ONE submit. `size="lg"` is the reference's `.ftd-modal--lg`; today's
        BootstrapVue `size="lg"`, `title-class="font-18"` and `hide-footer` go where the shell takes over.
        THE MODAL STAYS NON-`static`, deliberately: BootstrapVue transports it to `<body>`, where it leaves
        every `.ftd` on the page and inherits none of the four theme variables, which is exactly why the
        shell puts `ftd` and the colours on the modal element itself (`@show="themeOn"`). Measured by
        `T32-media-tab` (its note sections 3(e2) and 13) on the pane this modal is mounted inside.

        THE BODY IS NOT DRAWN BY THIS FILE, and that is a known gap rather than an omission. The rows are
        `ChangeCommonFields`, a component in no brief and no piece's to open (the orchestrator's ruling R4,
        on T31's merged precedent), so the reference's `.ftd-fields--one` of `.ftd-field` / `.ftd-input` and
        its two `.ftd-checks` ticks are not reached here. The build note lists class by class what the body
        therefore does not match, and that the mend is one small piece owning that file. The field set is
        untouched either way: "restyle only", and no field is added, removed or reordered.

        THE SUBMIT READS "Save", which is the task's own word ("a `--right` footer of Cancel and Save",
        `tasks-T32-T33.md`); today's read "Update". It keeps all three of its bindings: `:disabled`, the
        spinner and `v-on:click.once="addItem($event)"`.

        WHAT DOES NOT CHANGE, because this component is seen far outside T32 (three mounts, one of them
        `resources/js/layouts/main.vue`'s site-wide `shared-edit-image-notes`, a file no piece owns): the
        three modal ids built as `'create-'+item_type`, the `:ref`, `@hide="resetSelectedItem"`, `addItem`,
        `setSelectedItem`, `setDoneAction`, the `$bvModal.hide` at the end of `addItem`, and the
        `on-new-item-adding` emit. `ImageGallery.mixin.js` and `layouts.mixin.js` reach all of them by ref
        and by id and neither is opened.
    -->
    <AFModal :id="'create-'+item_type"
             size="lg"
             :ref="'create-'+item_type"
             :title="selected_item ? getTitleFor(selected_item, 'parts') : modal_title"
             :sub="selected_item && selected_item.name ? selected_item.name : ''"
             @hide="resetSelectedItem">

        <ChangeCommonFields :add-form="addForm" :required_fields="required_fields"/>

        <template #submit>
            <button type="button" class="ftd-btn" :disabled="isSavingItem" v-on:click.once="addItem($event)">
                <span v-show="!isSavingItem">Save</span>
                <div v-show="isSavingItem" class="spinner-border spinner-border-sm" role="status">
                    <span class="sr-only">Saving...</span>
                </div>
            </button>
        </template>
    </AFModal>
</template>

<script>
import Resource from '@/api/resource';
import ChangeCommonFields from "./ChangeCommonFields";
import AFModal from "@/components/modals/AFModal";
const imageResource = new Resource('api/assetflow/images/editNotes');

export default {

    name: "EditImageNotes",
    props: ['modal_title', 'item_type'],
    mixins: [],
    components: {ChangeCommonFields, AFModal},
    data(){
        return {
            addForm:{
                name: null,
                description: null,
                is_featured: null,
            },
            required_fields:{
                name: {
                    key: 'name',
                    label: 'Image Title',
                    type: 'text'
                },
                description: {
                    key: 'description',
                    label: 'Image Notes',
                    type: 'textarea'
                },
                is_featured: {
                    key: 'is_featured',
                    label: 'Featured',
                    type: 'radio-select',
                    options:[
                        { id: 1, name: 'Yes' },
                        { id: 0, name: 'No' }
                    ]
                },
            },
            isSavingItem: false,
            selected_item: null,
            list_disabled: null,
            item_index: null,
            done_action: null
        }
    },
    created() {
    },
    methods:{
        resetSelectedItem(){
            this.setSelectedItem({});
            this.isSavingItem = false;
        },
        fillSelectedItem() {
            if (this.selected_item) {
                this.addForm.name = this.selected_item.name;
                this.addForm.description = this.selected_item.description;
                if (this.selected_item.hasOwnProperty('is_featured')){
                    this.addForm.is_featured = this.required_fields.is_featured.options[this.selected_item.is_featured === 1 ? 0 : 1];
                }
            }
        },
        resetFormValues(){
            this.addForm = {
                name: null,
                description: null,
                is_featured: null,
            };
        },
        setDoneAction(done_action){
            if (done_action){
                this.done_action = done_action;
            }
        },
        setSelectedItem(item){
            if (item){
                if (item.hasOwnProperty('index')){
                    this.item_index = item.index;
                }
                this.selected_item = item;
                this.fillSelectedItem();
            }else{
                this.selected_item = null;
                this.resetFormValues();
            }
        },

        async addItem(event){
            this.isSavingItem = true;

            var params = {
                name: this.addForm.name,
                description: this.addForm.description,
                is_featured: this.addForm.is_featured ? this.addForm.is_featured.id : 0,
                edit_type : 'edit_notes'
            };
            if (this.selected_item && this.selected_item.id !== -99){
                params.item_id = this.selected_item.id;
            }

            const { data } = await imageResource.store(params);


            let new_item = data.data.items;

            let status_message = 'Error!',
                status_class = 'danger',
                message = data.data.msg;

            if (new_item){
                status_message = 'Success!';
                message = (this.selected_item && this.selected_item.id !== -99 ? 'Edited' : 'Added') + ' Successfully';
                status_class = 'success';
            }

            this.presentToast(status_message,
                message,
                status_class,
                3000,
                true,
                true);

            this.isSavingItem = false;
            this.$bvModal.hide('create-'+this.item_type);
            this.resetSelectedItem();

            if (this.done_action !== null){
                this.done_action(new_item);
            }else{
                this.$emit('on-new-item-adding', new_item, this.item_index);
            }
        }
    }
}
</script>
